import { api } from './baseApi';
export var menuApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getFilesByRestId: builder.query({
                query: function (params) {
                    return ({
                        url: "/restaurants/".concat(params.restaurantId, "/files"),
                        method: 'GET',
                        // params: {params.restaurantId},
                        // credentials: 'include',
                        // params: params,
                    });
                },
                providesTags: ['Menu'],
            }),
            createFile: builder.mutation({
                query: function (body) {
                    return ({
                        method: 'POST',
                        url: "/restaurants/newFiles",
                        body: body,
                    });
                },
                invalidatesTags: ['Menu'],
            }),
            deleteFile: builder.mutation({
                query: function (_a) {
                    var fileId = _a.fileId, bucketName = _a.bucketName, restaurantId = _a.restaurantId;
                    return ({
                        method: 'DELETE',
                        url: "/restaurants/file/delete",
                        body: { fileId: fileId, bucketName: bucketName, restaurantId: restaurantId },
                    });
                },
                invalidatesTags: ['Menu'],
            }),
        });
    },
});
export var useCreateFileMutation = menuApi.useCreateFileMutation, useDeleteFileMutation = menuApi.useDeleteFileMutation, useGetFilesByRestIdQuery = menuApi.useGetFilesByRestIdQuery, useLazyGetFilesByRestIdQuery = menuApi.useLazyGetFilesByRestIdQuery;
